import { useAppDispatch, useAppSelector } from '@reduxStore';
import { NavItemProps } from '../types';
import NavigationBarItem from '../NavigationBarItem';
import { Badge } from '@mui/material';
import { useFetchDocumentsApprovalQuery } from '@api/Trinium/Endpoints/Document/slice';
import DocumentsIcon from '@mui/icons-material/DescriptionTwoTone';
import { queueModal } from '@components/Modals/modalSlice';
import { selectAppFeatures, selectTerminal } from '@/Infrastructure/Utilities/appSelectors';

export default function DocumentControlItem({ isDesktopOpen, ...props }: NavItemProps) {
	const selectedTerminal = useAppSelector((state) => selectTerminal(state));
	const features = useAppSelector((state) => selectAppFeatures(state));
	const appDispatch = useAppDispatch();

	const { data: documents } = useFetchDocumentsApprovalQuery(
		{
			terminalNumber: selectedTerminal?.number ?? ''
		},
		{
			skip: !selectedTerminal?.number || !features?.documentControl || !selectedTerminal.isMc3Terminal,
			refetchOnMountOrArgChange: true
		}
	);

	if (!selectedTerminal || !features?.documentControl || !selectedTerminal.isMc3Terminal) return <></>;

	return (
		<NavigationBarItem
			key='navbar-item-edi-load-tenders'
			item={{
				displayText: 'Document Control',
				icon: (
					<Badge
						badgeContent={documents?.length.toString() || '0'}
						color='info'
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right'
						}}
						sx={{
							'& .MuiBadge-badge': {
								right: 8,
								bottom: 2
							}
						}}
					>
						<DocumentsIcon />
					</Badge>
				),
				title: 'Document Control',
				onClick: () => {
					appDispatch(
						queueModal({
							Component: 'documentControlModal'
						})
					);
				}
			}}
			open={isDesktopOpen}
			{...props}
		/>
	);
}
